import Reaction from "./reaction";
import {GroupedData} from "../../data-structures/group";
import {SortDirection} from "../../data-structures/sort";

const debug = false
// const debug = "Notes"

export default class Reactions {

    private _models: Reaction[]

    constructor(models:Reaction[]=[]) {
        this._models = models
    }

    get isEmpty():boolean {
        return _.isEmpty(this._models)
    }

    isMyReaction(reactionType:number):boolean {
        return !!_.find(this._models, (reaction)=>{
            return reaction.type === reactionType && reaction.userId === gd.user.id
        })
    }

    toggleMyReaction(reactionType:number) {
        if (this.isMyReaction(reactionType)) {
            this.removeMyReaction(reactionType)
        } else {
            this.addMyReaction(reactionType)
        }
    }

    addMyReaction(reactionType:number) {

        // make sure we don't add it twice
        if (this.isMyReaction(reactionType)) return false

        this._models.push(new Reaction(reactionType, gd.user.id, moment()))
    }

    removeMyReaction(reactionType:number) {
        _.remove(this._models, (reaction:Reaction)=>{
            return reaction.type === reactionType && reaction.userId === gd.user.id
        })
    }

    get groupedByType():GroupedData {

        const result:GroupedData = _(this._models)
            .groupBy((model:Reaction)=>{
                return model.type;
            })
            .toPairs()
            .map((group)=> {

                const reactionType = Number(group[0])

                return {
                    value       : reactionType,
                    sortValue   : reactionType,
                    label       : group[0],
                    items       : group[1]  // Reactions[]
                }
            })
            .orderBy((group)=>group.sortValue, SortDirection.ASC as any)
            .value() as GroupedData

        return result
    }

    static initFromJson(data:JSONArray) {
        const collection = new Reactions([])

        _.map(data, (record:JSONObject)=>{
            collection.add(Reaction.initFromJson(record))
        })

        // collection.sort()

        return collection
    }


    add(reaction: Reaction) {
        this._models.push(reaction)
    }

    toJSON():JSONArray {
        return _.map(this._models, (model:Reaction)=>{
            return model.toJSON()
        })
    }

}